export const START_LOADING = 'START_LOADING';
export const START_LOADING_BLACK = 'START_LOADING_BLACK';
export const END_LOADING = 'END_LOADING';
